module.exports = __webpack_public_path__ + "static/media/playspace_section2.cdf004a5.png";